import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import { useDropzone } from 'react-dropzone';
import Tooltip from 'react-tooltip-lite';
import { Icon } from '../../components/Icons';
import { EmptyState } from './EmptyState';
import styles from './style.module.css';

interface Props {
  item?: any;
  id: string;
  principal: boolean;
  options?: Option[];
  setMain?: (id: string) => void;
  remove: (id: string) => void;
  onDrop?: (files: any) => void;
  hasChange?: boolean;
}

interface Option {
  name: string;
  action?: () => void;
  hasChangeOption?: boolean;
}

export const PhotoCard = ({ item, id, remove, setMain, hasChange = false, onDrop }: Props) => {
  if (!item.url && !item.base64) {
    return <EmptyState key="empty" />;
  }

  const [tooltipStatus, setTooltipStatus] = useState(false);
  const tooltipRef = useRef(null);
  useEffect(() => {
    if (!document) {
      return;
    }
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleClickOutside = (e: any) => {
    if (
      e.target &&
      e.target.id !== id &&
      e.srcElement.parentNode &&
      e.srcElement.parentNode.id !== item.id &&
      e.target.id !== 'option'
    ) {
      setTooltipStatus(false);
    }
  };

  const handleScroll = () => {
    if (tooltipStatus) {
      setTooltipStatus(false);
    }
  };

  const renderOptions = ({ name, action, hasChangeOption }: Option) => {
    const optionStyle = classnames('ma0 ttu f12 b nowrap pointer', {
      'blaze-orange pb4': name !== 'EXCLUIR',
      abbey: name === 'EXCLUIR',
    });
    const borderNone = classnames('bb b--alto bt-0', styles.removeBorder);
    if (hasChangeOption) {
      const { getRootProps, getInputProps } = useDropzone({ onDrop, accept: 'image/*' });
      return (
        <div className={borderNone} {...getRootProps()} key={item.id + name}>
          <input {...getInputProps()} />
          <p onClick={action} className={optionStyle} id="option">
            {name}
          </p>
        </div>
      );
    }
    return (
      <div className={borderNone} key={item.id + name}>
        <p onClick={action} className={optionStyle} id="option">
          {name}
        </p>
      </div>
    );
  };

  const tooltipOptions = () => {
    let options = [
      {
        name: 'EXCLUIR',
        action: () => remove(item.id),
        hasChangeOption: false,
      },
    ];

    if (hasChange) {
      options = [
        {
          name: 'ALTERAR FOTO',
          action: () => {
            setTooltipStatus(!tooltipStatus);
          },
          hasChangeOption: hasChange,
        },
        {
          name: 'EXCLUIR',
          action: () => remove(item.id),
          hasChangeOption: false,
        },
      ];
    }

    if (!item.principal) {
      options = [
        {
          name: 'TORNAR PRINCIPAL',
          action: () => setMain && setMain(item.id),
          hasChangeOption: false,
        },
        {
          name: 'EXCLUIR',
          action: () => remove(item.id),
          hasChangeOption: false,
        },
      ];
    }

    return (
      options && (
        <div ref={tooltipRef} key={`list${item.id}`}>
          {options.map(renderOptions)}
        </div>
      )
    );
  };

  const onClick = () => {
    setTooltipStatus(!tooltipStatus);
  };

  const classNameTooltip = classnames(
    'absolute bg-white br2 pa0 pointer ba b--alto',
    styles.position,
  );

  return (
    <div className="w-100 h-100 flex justify-center items-center relative" key={item.id}>
      <div className="w-100 h-100 overflow-hidden br3 flex items-center">
        <img key={item.id} src={item.url} className="w-100 h-auto" />
        <button type="button" onClick={onClick} className={classNameTooltip} id={item.id}>
          <Icon name="SvgIconGear" />
          <Tooltip
            key={item.id}
            content={tooltipOptions()}
            background="white"
            isOpen={tooltipStatus}
            tipContentHover
            direction="up"
            distance={40}
            arrow
            forceDirection
          >
            {' '}
          </Tooltip>
        </button>
      </div>
    </div>
  );
};
